import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../i18n';
import {NavLink} from 'react-router-dom';
import useInterval from '../../hooks/use-interval';
import axios from 'axios';
import config from '../../config';
import statuses from './statuses';
import NavItemStatusIndicator from './nav-item-status-indicator';

export default function NavItem(props) {
  const {id, url, name, matchExact, statusUrl} = props.navData;
  const [status, setStatus] = React.useState(statuses.ok);
  const [statusMessage, setStatusMessage] = React.useState();
  const [statusMessageOpts, setStatusMessageOpts] = React.useState();

  const reloadStatus = React.useCallback(async () => {
    let newStatus = statuses.error;
    let newMessage = undefined;
    let newMessageOpts = undefined;

    try {
      const result = (
        await axios.get(statusUrl, {
          headers: {'X-No-Session-Refresh': 'true'},
        })
      ).data;
      newStatus = result.status;
      newMessage = result.message;
      newMessageOpts = result.message_opts;
    } catch (ex) {
      newMessage = 'error.status-check-failed';
    }

    setStatus(newStatus);
    setStatusMessage(newMessage);
    setStatusMessageOpts(newMessageOpts);
    props.onStatusChange(id, newStatus);
  }, [statusUrl]);

  const statusInterval = useInterval(reloadStatus, config.rapidRefreshIntervalMilliseconds);

  React.useEffect(() => {
    if (statusUrl) {
      reloadStatus();
      statusInterval.start();
    }
  }, [statusUrl]);

  return (
    <li className={`link`}>
      <NavItemStatusIndicator status={status} message={statusMessage} messageOpts={statusMessageOpts} />
      <NavLink to={url} activeClassName="selected" exact={matchExact}>
        <I18n t={name} />
      </NavLink>
    </li>
  );
}

NavItem.propTypes = {
  /** The navigation data to render. Of form `{id, name, url, matchExact}` */
  navData: PropTypes.object.isRequired,
  /** A callback to execute when the status changes. Passes the status string. */
  onStatusChange: PropTypes.func.isRequired,
};
